<template lang="pug">
el-input(
  id='search'
  :placeholder='placeholder'
  v-model='value'
  autofocus
  clearable
  @clear='clear'
  @keyup.native.enter='search')
  el-button(
    id='btn-search'
    slot='append'
    icon='el-icon-search'
    @click='search')
</template>

<script>
export default {
  name: "Search",
  props: {
    query: { type: String, default: "" },
    placeholder: { type: String, default: "Поиск" },
  },
  data() {
    return {
      value: this.$props.query,
    };
  },
  watch: {
    query() {
      this.value = this.$props.query;
    },
  },
  methods: {
    clear() {
      this.$emit("clear");
      this.search();
    },
    search() {
      this.$emit("update:query", this.value);
      this.$emit("search", this.value);
    },
  },
};
</script>
